import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import { ITypedBaseResponse } from '@nkr/models/base-response';
import { AppActionCreators } from '@nkr/store/application';
import { AuthActionCreators } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IOpoSummary {
    id: number,
    alias: string,
    name: string
}

const OpoPortalEntry = ({ match, history }: RouteComponentProps<{ opoId: string }>) => {
    const { dispatch } = useAppHookContext();
    const [error, setError] = useState('');

    const opoId = Number(match.params.opoId);

    useEffect(() => {
        let isCurrent = true;

        const openPortal = async () => {
            setError('');

            await dispatch(AppActionCreators.showLoadingAsync('Opening OPO portal, one moment please...'));

            try {
                const response: ITypedBaseResponse<IOpoSummary> = await dispatch(AuthActionCreators.apiGet({ url: `${__API__}/opo/${opoId}` }));

                if (!isCurrent) {
                    return;
                }

                let { id, name, alias } = response.data.results;

                if (response && response.data.success) {
                    dispatch(AppActionCreators.setPortalOpo({ id, name, alias }));
                    history.replace('/opo/action-center');
                } else {
                    setError('Unable to open the OPO portal for that OPO');
                }
            } catch (err) {
                if (isCurrent) {
                    setError('Unable to open the OPO portal for that OPO');
                }
            } finally {
                dispatch(AppActionCreators.hideLoading());
            }
        };

        openPortal();

        return () => {
            isCurrent = false;
        };
    }, [opoId]);

    return error ? <Alert bsStyle='danger' style={{ margin: 20 }}>{error}</Alert> : null;
}

export default OpoPortalEntry;
